export const toggleSidebar = (state) => {
  state.sidebar = !state.sidebar;
};

export const setSidebar = (state, value) => {
  state.sidebar = value;
};
